/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';

// initial state
const state = {
  downloadInProgress: null,
  manufacturers: [],
  pricing: null,
  sortDir: 'asc',
  sortProp: 'family',
  loaders: {
    manufacturers: false,
    pricing: false,
    document: false,
  },
  // ...window.INITIAL_STATE.pricingGuides,
};

// getters
const getters = {
  member_id: (state, getters, rootState, rootGetters) => rootGetters['main/member_id'],
  memberName: (state, getters, rootState, rootGetters) => rootGetters['main/memberName'],
  member_name: (state, getters, rootState, rootGetters) => lodash.kebabCase(rootGetters['main/memberName']),
  token: (state, getters, rootState, rootGetters) => rootGetters['auth/user']['token'],
  downloadInProgress: state => state.downloadInProgress,
  manufacturers: state => state.manufacturers,
  pricing: state => state.pricing,
  loaders: state => state.loaders,
  sortDir: state => state.sortDir,
  sortProp: state => state.sortProp,
  templates: (state) => {
    if (state.pricing) {
      return lodash.map(state.manufacturers, (manufacturer) => {
        return lodash.assign(manufacturer, state.pricing[manufacturer.name.strToLower()]);
      });
    }
    return [];
  },
};

// actions
const actions = {
  getManufacturers({ commit }) {
    commit('TOGGLE_LOADING', { key: 'manufacturers', value: true });
    return axios.get('/api/pricing-guides/manufacturers/getManufacturers/').then((response) => {
      commit('TOGGLE_LOADING', { key: 'manufacturers', value: false });
      commit('LOAD_MANUFACTURERS', response.data);
    });
  },
  getPricing({ commit, dispatch }) {
    commit('TOGGLE_LOADING', { key: 'pricing', value: true });
    return axios.get('/api/pricing-guides/manufacturers/getPricing/').then((response) => {
      commit('LOAD_PRICING', response.data);
      commit('TOGGLE_LOADING', { key: 'pricing', value: false });
      dispatch('main/setProperty', { key: 'globalLoading', value: false }, { root: true });
    });
  },
  downloadPricing({ commit, getters }, vendor) {
    commit('SET_PROPERTY', { key: 'downloadInProgress', value: true });
    commit('TOGGLE_LOADING', { key: 'documents', value: true });
    axios.get(`${CONFIG.get('BASE_URL')}/api/member/${getters.member_id}/info/getPricingLink/?vendor=${vendor}`)
      .then(({ data }) => {
        if (data !== undefined && data !== -1) {
          window.location = `${CONFIG.get('BASE_URL')}/api/member/${getters.member_id}/info/downloadPricingGuide/?vendor=${vendor}&template_id=${data.template_id}&member_name=${getters.member_name}&bearer=${getters.token}`;
        }
        commit('SET_PROPERTY', { key: 'downloadInProgress', value: false });
        commit('TOGGLE_LOADING', { key: 'documents', value: false });
      });
  },
  setSortDir({ commit }, payload) {
    commit('SET_SORT_DIR', payload);
  },
  setSortProp({ commit }, payload) {
    commit('SET_SORT_PROP', payload);
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  LOAD_MANUFACTURERS(state, payload) {
    state.manufacturers = payload;
  },
  LOAD_PRICING(state, payload) {
    state.pricing = payload;
  },
  SET_SORT_DIR(state, payload) {
    state.sortDir = payload;
  },
  SET_SORT_PROP(state, payload) {
    state.sortProp = payload;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
